import React, { useEffect, useState } from "react";
import { socket } from "../config/socket.config";
import { useDispatch, useSelector } from "react-redux";

const SocketProvider =()=> {

  const dispatch = useDispatch()


}

export default SocketProvider